import {computed, observable, makeObservable} from "mobx";
import type {AppState} from "../state/AppState";
import {XyiconFeature} from "../../generated/api/base";
import type {PortfolioDto, PortfolioFieldUpdateDto, SpaceDto} from "../../generated/api/base";
import type {OrgSearchResponseDto} from "../../generated/api/search";
import type {IModel} from "./Model";

export class Portfolio implements IModel, PortfolioDto {
	public static search(portfolio: Portfolio, search = "") {
		if (!search) {
			return true;
		}

		search = search.toLowerCase();

		const refId = portfolio.refId.toLowerCase();

		if (refId.indexOf(search) > -1) {
			return true;
		}

		const name = portfolio.name.toLowerCase();

		if (name.indexOf(search) > -1) {
			return true;
		}

		return false;
	}

	public readonly ownFeature = XyiconFeature.Portfolio;

	private _data: Partial<PortfolioDto & {spaces: SpaceDto[]}> = {};

	private _appState: AppState;

	constructor(data: PortfolioDto, appState: AppState) {
		makeObservable<this, "_data">(this, {
			_data: observable,
			id: computed,
			refId: computed,
			name: computed,
			typeId: computed,
			type: computed,
			typeName: computed,
			fieldData: computed,
			lastModifiedBy: computed,
			lastModifiedAt: computed,
			data: computed,
		});
		this._appState = appState;
		this.applyData(data);
	}

	public applyData(data: Partial<PortfolioDto & {spaces: SpaceDto[]}>) {
		this._data = {
			...this._data,
			...data,
		};
		(this._data.fieldData as Record<string, any>) = this._data.fieldData || {};
	}

	public applyUpdate(data: PortfolioFieldUpdateDto) {
		if (data.portfolioIDList.includes(this.id)) {
			this.applyFieldValues(data.fieldValues);
			this._data.lastModifiedAt = data.lastModifiedAt || this._data.lastModifiedAt;
			this._data.lastModifiedBy = data.lastModifiedBy || this._data.lastModifiedBy;
		}
	}

	public applyFieldValues(fieldValues: Record<string, any> | null) {
		if (fieldValues?.name !== undefined) {
			this.name = fieldValues.name;
		}
	}

	public get spaces() {
		return this._data.spaces ?? [];
	}

	public get id() {
		return this._data.portfolioID;
	}

	public get refId() {
		return this._data.portfolioRefID;
	}

	public set name(value: string) {
		this._data.name = value;
	}

	public get name() {
		return this._data.name ?? "";
	}

	// public get author()
	// {
	// 	return "John Doe";
	// }

	public set typeId(value: string) {
		this._data.portfolioTypeID = value;
	}

	public get typeId() {
		return this._data.portfolioTypeID;
	}

	public get type() {
		return this._appState.actions.getTypeById(this.typeId);
	}

	public get typeName() {
		return this.type?.name || "";
	}

	public get fieldData() {
		return this._data.fieldData || {};
	}

	public get linkedFieldData() {
		return (this._data as OrgSearchResponseDto).linkedFieldData ?? {};
	}

	public get status() {
		return "Active"; //return this._data.isDeleted ? "Deleted" : "Active";
	}

	public get lastModifiedBy() {
		return this._data.lastModifiedBy;
	}

	public get lastModifiedAt() {
		return this._data.lastModifiedAt;
	}

	public get data() {
		return this._data;
	}
}
